<template>
  <DrawerSlot>
    <div :class="style.wrapper">
      <DrawerPresentational
        :items="items"
        :getShowFlags="getShowFlg"
        :routerPush="routerPush"
      />
    </div>
  </DrawerSlot>
</template>

<script>
import DrawerPresentational from '@/components/Shared/Drawer/DrawerPresentational'
import drawerStyles from '@/components/Shared/Drawer/drawerStyles'
import simulation from '@/assets/images/advertiser/simulation@2x.png'
import viewList from '@/assets/images/advertiser/view-list.png'
import dashboard from '@/assets/images/advertiser/view-dashboard.png'

// メニュー内容作成にあたって必要最低限の情報

import { getters as drawerGetters } from '@/vuex/modules/ui/drawer/constants'
import DrawerSlot from '@/components/Shared/Drawer/DrawerSlot'
import { mapGetters } from 'vuex'
import { Account } from '@/models/Account'

const itemsBase = [
  {
    title: '広告主一覧',
    path: 'report',
    image: viewList,
    width: 18,
    height: 19,
  },
  {
    title: 'ダッシュボード',
    path: 'operation',
    image: dashboard,
    width: 18,
    height: 19,
  },
  {
    title: 'シミュレーション',
    path: 'simulations',
    image: simulation,
    width: 15,
    height: 16,
  },
]

// itemsBase を元に、Presentational Component に渡す item を作成する関数
const itemsBaseToItems = ({ items }) => {
  return items.map(o => {
    const title = o.title
    const url = `/loginlp/${o.path}`
    const image = o.image
    const width = o.width
    const height = o.height
    return { title, url, image, width, height }
  })
}

export default {
  name: 'LoginLpDrawer',
  components: { DrawerPresentational, DrawerSlot },
  data() {
    return {
      items: [],
      selectedMenu: '',
    }
  },
  computed: {
    ...mapGetters('account', ['isAdvertiser', 'isSimulationVisible']),
    openFlg() {
      return this.$store.getters[drawerGetters.showFlag]
    },
    color() {
      return this.$store.getters['colorTheme/color']
    },
    style() {
      return drawerStyles(this.color)
    },
    isShowSimulation() {
      if (!this.isSimulationVisible) {
        return false
      }
      return !this.isAdvertiser
    },
    userBelongType() {
      return this.$store.getters['account/belongType']
    },
    userBelongId() {
      return this.$store.getters['account/belongId']
    },
    userType() {
      return this.$store.getters['account/userType']
    },
  },
  watch: {
    async userBelongType() {
      await this.setIsHideRevenue()
      this.createMenuItems()
    },
    $route() {
      this.selectedMenu = this.$route.path
    },
    isShowSimulation() {
      this.createMenuItems()
    },
  },
  async created() {
    await this.setIsHideRevenue()
    this.createMenuItems()
  },
  methods: {
    async setIsHideRevenue() {
      if (!this.userBelongType || !this.userBelongId) return

      this.isHideRevenue = await Account.isHideRevenue(
        this.userBelongType,
        this.userBelongId,
        this.userType,
      )
    },
    routerPush(path) {
      this.$router.push({ path })
    },
    getShowFlg(url) {
      return this.$store.getters['drawerUriAuths/getShowFlg'](url)
    },
    createMenuItems() {
      if (this.isHideRevenue === undefined) return []

      const itemsBaseWithIsHideRevenue = this.isHideRevenue
        ? itemsBase.filter(item => !['operation'].includes(item.path))
        : itemsBase

      const items = this.isShowSimulation
        ? itemsBaseWithIsHideRevenue
        : itemsBaseWithIsHideRevenue.filter(item => item.path !== 'simulations')
      const menuItems = itemsBaseToItems({
        items,
      })
      this.items = menuItems
      // 出し分けするURLの配列
      const uriPaths = menuItems.map(o => o.url)
      const payload = {
        uriPaths,
      }
      this.$store.dispatch('drawerUriAuths/INITIALIZE', payload)
      this.selectedMenu = this.$route.path
    },
  },
}
</script>

<style scoped>
.selected {
  background-color: lightcyan;
}
</style>
